import * as _ from "lodash-es";
import IPurchase_Order from "../../../../models/IPurchase_Order";
import IPurchase_Order_Progress_State from "../../../../models/IPurchase_Order_Progress_State";
import PurchaseOrderStateEnum from "../../../../models/PurchaseOrderStateEnum";
import { ControlBar } from "../../../shared/ControlBar/ControlBar";
import OwButton from "../../../shared/OwButton/OwButton";
import OwCheckbox from "../../../shared/OwCheckbox/OwCheckbox";
import OwPrintButton from "../../../shared/OwPrintButton/OwPrintButton";
import OwSelectOption from "../../../shared/OwSelectOption/OwSelectOption";
import { IPurchaseOrderButtonsCallbacks } from "./IPurchaseOrderButtonsCallbacks";
import OwToggle from "@components/shared/OwToggle/OwToggle";

type Props = {
    purchaseOrder?: IPurchase_Order;
    purchaseOrderSteps: IPurchase_Order_Progress_State[];
    nextStep?: number;
    order_state_id?: number;
    isSubmitActive: boolean;
    isDownloading: boolean;
    isReadOnly: boolean;
    sendEmailWithPDF: boolean;
    isAdminSupplierUser: boolean;
    callbacks: IPurchaseOrderButtonsCallbacks;
};

export const PurchaseOrderButtons = (props: Props) => {
    const adminElements: any[] = [];
    const poActionElements: any[] = [];
    const printElements: any[] = [];

    printElements.push(<OwPrintButton />);

    if (props.isAdminSupplierUser) {
        adminElements.push(
            <div className={"d-flex align-items-center"}>
                <OwSelectOption
                    valueProp={"order_state_id"}
                    titleProp={"name"}
                    name={"order_state_id"}
                    options={props.purchaseOrderSteps}
                    fn={props.callbacks.handleChange}
                    selectedOption={{ order_state_id: props.order_state_id }}
                    selectedOptionProp={"order_state_id"}
                    translateTitle={true}
                    showBlankFirst={true}
                />
                <div className={"ms-2"}>
                    <OwButton
                        leftIconClass={"fad fa-random"}
                        title={"change"}
                        className={"btn-danger"}
                        fn={() => {
                            props.callbacks.advancePurchaseOrder(props.order_state_id);
                        }}
                        active={props.isSubmitActive}
                        disableOnActive={true}
                    />
                </div>
            </div>
        );
    }

    if (!_.isNil(props.nextStep)) {
        if (props.purchaseOrder?.po_state_id !== PurchaseOrderStateEnum.PRELIMINARY) {
            poActionElements.push(
                <OwButton
                    className={"btn-primary"}
                    title={"resend_email"}
                    leftIconClass={"fad fa-envelope"}
                    fn={props.callbacks.sendPurchaseOrder}
                    disabled={props.isDownloading}
                    disableOnActive={true}
                />
            );
            poActionElements.push(
                <OwButton
                    className={"btn-primary"}
                    title={"download_pdf"}
                    leftIconClass={"fad fa-download"}
                    fn={props.callbacks.downloadPdf}
                    disabled={props.isDownloading}
                    disableOnActive={true}
                />
            );
        }

        if (props.purchaseOrder?.po_state_id === PurchaseOrderStateEnum.PRELIMINARY) {
            poActionElements.push(
                <OwToggle
                    name={"sendEmailWithPDF"}
                    label={"email_on_submit"}
                    active={props.sendEmailWithPDF}
                    fn={props.callbacks.handleChange}
                />
            );
        }

        if (!props.isReadOnly) {
            poActionElements.push(
                <OwButton
                    title={"submit"}
                    fn={() => {
                        props.callbacks.advancePurchaseOrder();
                    }}
                    active={props.isSubmitActive}
                    disableOnActive={true}
                />
            );
        }

        if (props.purchaseOrder?.po_state_id !== PurchaseOrderStateEnum.PRELIMINARY && props.purchaseOrder?.Order) {
            poActionElements.push(
                <OwButton title={"create_order_shipment"} fn={props.callbacks.showShipmentSidebar} className={"btn-warning"} />
            );
        }
    }

    const hasSections = adminElements.length || poActionElements.length;

    return (
        <div className={"PurchaseOrderButtons"}>
            {hasSections ? (
                <ControlBar
                    name={"Purchase Order Buttons"}
                    sections={[
                        { name: "Print", elements: printElements },
                        { name: "Admin State Change", elements: adminElements },
                        { name: "PO Actions", elements: poActionElements },
                    ]}
                />
            ) : null}
        </div>
    );
};
